import envConfig from './env';

export { extraInfoConstants } from 'unihow-common/constants';

export const { AVAILABLE_LANGUAGES } = envConfig;
export const API_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const BASE_PATH = '';
export const COPY_SUFFIX = '_copy';
export const CSRF_COOKIE_NAME = 'UH.x-csrf-token';
export const INVALID_CSRF_TOKEN_TEXT = 'Invalid CSRF token';
export const DISPLAY_DATE_FORMAT = 'D.M.YYYY';
export const LANG_COOKIE_NAME = 'UNIHOW_LANG';
export const LONG_DISPLAY_DATE_FORMAT = 'D.M.YYYY, HH:mm';
export const PERSISTENT_COOKIE_LIFETIME = 365;
export const RESULTS_PER_PAGE = 10;
export const SENTRY_TRACKED_HEADERS = ['User-Agent'];
export const TILES_PER_PAGE = 8;
export const TITLE_PREFIX = 'UniHow';
export const LOGIN_TITLE = 'Login';
export const ERROR_TITLE = 'Error';

export const routes = {
  adminTools: {
    index: '/admin-tools',
    activityLog: '/admin-tools/activity-log',
    permissions: {
      index: '/admin-tools/permissions',
      manageUsers: {
        index: '/admin-tools/permissions/manage-users',
        user: '/admin-tools/permissions/manage-users/:userId'
      }
    }
  },
  accessibilityStatement: '/accessibility-statement',
  login: '/login',
  index: '/',
  responded: '/responded',
  surveys: {
    index: '/surveys',
    hulSurveys: {
      index: '/surveys/hul-surveys',
      startSurvey: {
        index: '/surveys/hul-surveys/start-survey',
        contents: {
          index: '/surveys/hul-surveys/start-survey/contents',
          questions: '/surveys/hul-surveys/start-survey/contents/questions',
          extraSurveyPart: '/surveys/hul-surveys/start-survey/contents/extra-survey-part'
        },
        messages: '/surveys/hul-surveys/start-survey/messages',
        participants: '/surveys/hul-surveys/start-survey/participants',
        researchConsent: '/surveys/hul-surveys/start-survey/research-consent'
      },
      survey: {
        index: '/surveys/hul-surveys/:surveyId',
        dimension: '/surveys/hul-surveys/:surveyId/dimension/:dimensionId',
        participants: {
          index: '/surveys/hul-surveys/:surveyId/participants',
          edit: '/surveys/hul-surveys/:surveyId/participants/edit'
        },
        close: '/surveys/hul-surveys/:surveyId/close',
        edit: {
          index: '/surveys/hul-surveys/:surveyId/edit',
          contents: {
            index: '/surveys/hul-surveys/:surveyId/edit/contents',
            questions: '/surveys/hul-surveys/:surveyId/edit/contents/questions',
            extraSurveyPart: '/surveys/hul-surveys/:surveyId/edit/contents/extra-survey-part'
          },
          messages: '/surveys/hul-surveys/:surveyId/edit/messages',
          participants: '/surveys/hul-surveys/:surveyId/edit/participants',
          researchConsent: '/surveys/hul-surveys/:surveyId/edit/research-consent'
        },
        reschedule: '/surveys/hul-surveys/:surveyId/reschedule',
        reminder: '/surveys/hul-surveys/:surveyId/reminder',
        reopen: '/surveys/hul-surveys/:surveyId/reopen'
      }
    },
    husSurveys: {
      index: '/surveys/hus-surveys',
      startSurvey: {
        index: '/surveys/hus-surveys/start-survey',
        contents: {
          index: '/surveys/hus-surveys/start-survey/contents'
        },
        messages: '/surveys/hus-surveys/start-survey/messages',
        participants: '/surveys/hus-surveys/start-survey/participants'
      },
      survey: {
        index: '/surveys/hus-surveys/:surveyId',
        dimension: '/surveys/hus-surveys/:surveyId/dimension/:dimensionId',
        close: '/surveys/hus-surveys/:surveyId/close',
        edit: {
          index: '/surveys/hus-surveys/:surveyId/edit',
          contents: {
            index: '/surveys/hus-surveys/:surveyId/edit/contents'
          },
          messages: '/surveys/hus-surveys/:surveyId/edit/messages',
          participants: '/surveys/hus-surveys/:surveyId/edit/participants'
        }
      }
    },
    hupSurveys: {
      index: '/surveys/hup-surveys',
      startSurvey: {
        index: '/surveys/hup-surveys/start-survey',
        contents: {
          index: '/surveys/hup-surveys/start-survey/contents',
          questions: '/surveys/hup-surveys/start-survey/contents/questions',
          extraSurveyPart: '/surveys/hup-surveys/start-survey/contents/extra-survey-part'
        },
        messages: '/surveys/hup-surveys/start-survey/messages',
        participants: '/surveys/hup-surveys/start-survey/participants',
        researchConsent: '/surveys/hup-surveys/start-survey/research-consent'
      },
      survey: {
        index: '/surveys/hup-surveys/:surveyId',
        dimension: '/surveys/hup-surveys/:surveyId/dimension/:dimensionId',
        participants: {
          index: '/surveys/hup-surveys/:surveyId/participants',
          edit: '/surveys/hup-surveys/:surveyId/participants/edit'
        },
        close: '/surveys/hup-surveys/:surveyId/close',
        edit: {
          index: '/surveys/hup-surveys/:surveyId/edit',
          contents: {
            index: '/surveys/hup-surveys/:surveyId/edit/contents',
            questions: '/surveys/hup-surveys/:surveyId/edit/contents/questions',
            extraSurveyPart: '/surveys/hup-surveys/:surveyId/edit/contents/extra-survey-part'
          },
          messages: '/surveys/hup-surveys/:surveyId/edit/messages',
          participants: '/surveys/hup-surveys/:surveyId/edit/participants',
          researchConsent: '/surveys/hup-surveys/:surveyId/edit/research-consent'
        },
        reschedule: '/surveys/hup-surveys/:surveyId/reschedule',
        reminder: '/surveys/hup-surveys/:surveyId/reminder',
        reopen: '/surveys/hup-surveys/:surveyId/reopen'
      }
    },
    hutSurveys: {
      index: '/surveys/hut-surveys',
      startSurvey: {
        index: '/surveys/hut-surveys/start-survey',
        contents: {
          index: '/surveys/hut-surveys/start-survey/contents',
          questions: '/surveys/hut-surveys/start-survey/contents/questions',
          extraSurveyPart: '/surveys/hut-surveys/start-survey/contents/extra-survey-part'
        },
        messages: '/surveys/hut-surveys/start-survey/messages',
        participants: '/surveys/hut-surveys/start-survey/participants',
        researchConsent: '/surveys/hut-surveys/start-survey/research-consent'
      },
      survey: {
        index: '/surveys/hut-surveys/:surveyId',
        dimension: '/surveys/hut-surveys/:surveyId/dimension/:dimensionId',
        participants: {
          index: '/surveys/hut-surveys/:surveyId/participants',
          edit: '/surveys/hut-surveys/:surveyId/participants/edit'
        },
        close: '/surveys/hut-surveys/:surveyId/close',
        edit: {
          index: '/surveys/hut-surveys/:surveyId/edit',
          contents: {
            index: '/surveys/hut-surveys/:surveyId/edit/contents',
            questions: '/surveys/hut-surveys/:surveyId/edit/contents/questions',
            extraSurveyPart: '/surveys/hut-surveys/:surveyId/edit/contents/extra-survey-part'
          },
          messages: '/surveys/hut-surveys/:surveyId/edit/messages',
          participants: '/surveys/hut-surveys/:surveyId/edit/participants',
          researchConsent: '/surveys/hut-surveys/:surveyId/edit/research-consent'
        },
        reschedule: '/surveys/hut-surveys/:surveyId/reschedule',
        reminder: '/surveys/hut-surveys/:surveyId/reminder',
        reopen: '/surveys/hut-surveys/:surveyId/reopen'
      }
    }
  },
  surveySchemas: {
    index: '/survey-schemas',
    schemas: {
      index: '/survey-schemas/schemas',
      schema: {
        index: '/survey-schemas/schemas/:surveySchemaId',
        copy: {
          index: '/survey-schemas/schemas/:surveySchemaId/copy',
          surveyParts: '/survey-schemas/schemas/:surveySchemaId/copy/survey-parts',
          extraSurveyPart: '/survey-schemas/schemas/:surveySchemaId/copy/extra-survey-part',
          preview: '/survey-schemas/schemas/:surveySchemaId/copy/preview'
        },
        edit: {
          index: '/survey-schemas/schemas/:surveySchemaId/edit',
          surveyParts: '/survey-schemas/schemas/:surveySchemaId/edit/survey-parts',
          extraSurveyPart: '/survey-schemas/schemas/:surveySchemaId/edit/extra-survey-part',
          preview: '/survey-schemas/schemas/:surveySchemaId/edit/preview'
        },
        newVersion: {
          index: '/survey-schemas/schemas/:surveySchemaId/new-version',
          surveyParts: '/survey-schemas/schemas/:surveySchemaId/new-version/survey-parts',
          extraSurveyPart: '/survey-schemas/schemas/:surveySchemaId/new-version/extra-survey-part',
          preview: '/survey-schemas/schemas/:surveySchemaId/new-version/preview'
        }
      },
      create: {
        index: '/survey-schemas/schemas/create',
        surveyParts: '/survey-schemas/schemas/create/survey-parts',
        extraSurveyPart: '/survey-schemas/schemas/create/extra-survey-part',
        preview: '/survey-schemas/schemas/create/preview'
      }
    },
    surveyParts: {
      index: '/survey-schemas/survey-parts',
      surveyPart: {
        index: '/survey-schemas/survey-parts/:surveyPartId',
        edit: {
          index: '/survey-schemas/survey-parts/:surveyPartId/edit',
          preview: '/survey-schemas/survey-parts/:surveyPartId/edit/preview'
        },
        newVersion: {
          index: '/survey-schemas/survey-parts/:surveyPartId/new-version',
          preview: '/survey-schemas/survey-parts/:surveyPartId/new-version/preview'
        },
        copy: {
          index: '/survey-schemas/survey-parts/:surveyPartId/copy',
          preview: '/survey-schemas/survey-parts/:surveyPartId/copy/preview'
        }
      },
      create: {
        index: '/survey-schemas/survey-parts/create',
        preview: '/survey-schemas/survey-parts/create/preview'
      }
    },
    extraSurveyParts: {
      index: '/survey-schemas/extra-survey-parts',
      surveyPart: {
        index: '/survey-schemas/extra-survey-parts/:surveyPartId',
        edit: {
          index: '/survey-schemas/extra-survey-parts/:surveyPartId/edit',
          preview: '/survey-schemas/extra-survey-parts/:surveyPartId/edit/preview'
        },
        copy: {
          index: '/survey-schemas/extra-survey-parts/:surveyPartId/copy',
          preview: '/survey-schemas/extra-survey-parts/:surveyPartId/copy/preview'
        }
      },
      create: {
        index: '/survey-schemas/extra-survey-parts/create',
        preview: '/survey-schemas/extra-survey-parts/create/preview'
      }
    }
  },
  survey: {
    index: '/survey/:surveyId',
    introduction: '/survey/:surveyId/introduction',
    surveyPart: '/survey/:surveyId/page/:page',
    researchConsent: '/survey/:surveyId/research-consent',
    feedback: {
      index: '/survey/:surveyId/feedback',
      responses: '/survey/:surveyId/feedback/responses'
    },
    responseSuccess: '/survey/:surveyId/response-success'
  },
  surveySubmitted: '/survey-submitted',
  error: '/error',
  surveyTimeout: '/survey-timeout'
};

export const EMPTY_PAGE = {
  content: [],
  first: true,
  last: true,
  number: 0,
  size: 0,
  totalElements: 0,
  totalPages: 1
};

export const courseUnitRealisationWarnings = {
  MISSING_COURSE_NAME: 'MISSING_COURSE_NAME',
  MISSING_EMAILS: 'MISSING_EMAILS',
  MISSING_EPPNS: 'MISSING_EPPNS'
};

export const participantErrors = {
  NOT_FOUND: 'NOT_FOUND',
  NO_EMAIL: 'NO_EMAIL',
  DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
  INVALID_EMAIL: 'INVALID_EMAIL'
};

export const participantWarnings = {
  ALREADY_IN_SURVEY: 'ALREADY_IN_SURVEY',
  CHANGING_EMAIL: 'CHANGING_EMAIL'
};

export const sortDirections = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC'
};

export const surveyFieldIds = {
  TITLE: 'title',
  DEGREE_PROGRAM_CODE: 'degreeProgramCode',
  DESCRIPTION: 'description',
  PARTICIPANTS_INPUT: 'participantsInput',
  INTRODUCTION: 'introduction',
  CONCLUSION: 'conclusion',
  SCHEMA: 'schema',
  INVITATION_TITLE: 'invitationEmailTitle',
  INVITATION_CONTENT: 'invitationEmailContent',
  REMINDER_TITLE: 'reminderEmailTitle',
  REMINDER_CONTENT: 'reminderEmailContent',
  ENDING_TITLE: 'endingEmailTitle',
  ENDING_CONTENT: 'endingEmailContent',
  RESEARCH_CONSENT: 'researchConsentNeeded',
  RESEARCH_AGREEMENT: 'researchAgreement',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  REMINDER_SCHEDULES: 'reminderSchedules'
};

export const validation = {
  surveyPart: {
    validationType: {
      QUESTION: 'question'
    },
    validationProblem: {
      CODE: 'code'
    },
    validationReason: {
      INVALID: 'invalid',
      DUPLICATE: 'duplicate'
    }
  }
};

export const authMethods = {
  IN_APP: 'local',
  SHIBBOLETH: 'saml',
  MULTI_SAML: 'multi-saml'
};

export const surveySchemaActionTypes = {
  COPY: 'COPY',
  VERSION: 'VERSION',
  EDIT: 'EDIT'
};

export const EDIT = 'EDIT';
export const NEW_VERSION = 'NEW_VERSION';
export const COPY = 'COPY';
export const CREATE = 'CREATE';

export const IDENTIFIER = 'code';
export const DESCRIPTION = 'description';
export const SURVEY_TYPE = 'surveyType';

export const SURVEY_TITLE = 'survey_title';

export const STUDENT_PSYCHOLOGIST_REGEX = /{{STUDENT_PSYCHOLOGIST_LINK}}/g;

export const STUDENT_PSYCHOLOGIST_LINK_TAG = '<a href={{STUDENT_PSYCHOLOGIST_LINK}}>{{STUDENT_PSYCHOLOGIST_LINK}}</a>';

/**
 * Placeholder object representing "no degree program selected" in the UI.
 *
 * - Should be used internally in the frontend only.
 * - When submitting to the backend, convert this to `null`.
 */
export const DEGREE_PROGRAM_NOT_SELECTED = {
  code: 'NOT_SELECTED',
  groupId: '',
  name: null,
  validity: null
};

export const ROLE_KIND_ORDER = [
  'ADMIN',
  'VIEWER',
  'PARTICIPANT_VIEWER',
  'DATA_EXPORTER',
  'RESTRICTED_DATA_EXPORTER',
  'RESTRICTED_VIEWER'
];

export const SURVEY_TYPE_ORDER = ['HUL', 'HUS', 'HUP', 'HUT'];
